import { CommunityWins, Users } from '@platform/client';
import { Button } from '@platform/components';
import { useState } from 'react';
import { PaginationBar } from '../../../components/PaginationBar';
import { CommunityBackButton } from '../community-home/CommunityBackButton';
import { CommunityCard } from '../CommunityCard';
import { CommunityListPanel } from '../CommunityListPanel';

export const CommunityWinsPage = () => {
  const user = Users.useGetCurrentUser();

  const isRepresentative =
    user.isSuccess &&
    (user.data.role === 'representative' || user.data.role === 'representative_with_opportunity');

  const [page, setPage] = useState(0);
  const [pageSize, _] = useState(8);

  const communityWins = CommunityWins.useGetCommunityWins({ page, limit: pageSize });
  const numCommunityWins = CommunityWins.useCountCommunityWins();
  const numPages = Math.ceil((numCommunityWins.data || pageSize) / pageSize);

  const onPageSelect = (page: number) => {
    setPage(page - 1);
  };

  return (
    <div className='w-full p-4 flex flex-col pt-10 mw-[317px] max-w-[317px] md:w-[798px] md:max-w-[798px]'>
      <CommunityBackButton />
      <div className='flex flex-row justify-between items-center'>
        <h1 className='text-display-sm font-gray-700 py-10'>Community wins 🎉</h1>
        {isRepresentative && (
          <Button
            href='https://forms.zohopublic.com/movingworlds/form/MovingWorldsCommunityWins/formperma/HT0_wPShqi4H_nahVeMroBqrMa3nBO-rbYeZcARU8IM'
            variant='primary'
            size='md'
            additionalClassnames='mt-5'
          >
            Submit your win
          </Button>
        )}
      </div>

      <CommunityListPanel>
        {communityWins.data?.map((win) => {
          return (
            <CommunityCard
              key={win.id}
              title={win.title}
              description={win.description}
              link={win.link ?? undefined}
              date={new Date(win.createdAt)}
              cta={'Read More'}
            />
          );
        })}
      </CommunityListPanel>
      <PaginationBar onPageSelect={onPageSelect} currentPage={page + 1} numPages={numPages} />
    </div>
  );
};
